export const findOpenedConversations = (state, conversations) =>
  (state.conversations?.[state.selectedChannelUID] || []).filter(
    conversationId =>
      // check if it is an opened conversation. If it is, it doesn't have messages yet,
      // it stores on the local storage (no server)
      // TODO: remove this condition when API is ready
      // find opened secret conversation
      state.chats.byId?.[conversationId]?.isSecret ||
      // find opened conversation
      (!state.chats.byId?.[conversationId]?.lastMessageId &&
        // check if conversation is already exists
        !conversations.some(({ chatId }) => chatId === conversationId)),
  );
